import React from 'react';
import { useParams, Link } from 'react-router-dom';

function PaymentCancelled() {
  const { paymentId, merchantSlug } = useParams();

  return (
    <div className="max-w-md mx-auto p-6">
      {/* Cancelled Icon */}
      <div className="flex flex-col items-center gap-4 p-6 bg-white dark:bg-background-dark rounded-xl shadow-sm mb-6">
        <div className="flex items-center justify-center w-20 h-20 rounded-full bg-orange-100 dark:bg-orange-900/30">
          <span className="material-symbols-outlined text-orange-500 text-5xl">cancel</span>
        </div>
        <div className="text-center">
          <h1 className="text-2xl font-bold text-text-light dark:text-text-dark mb-2">
            付款已取消
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            您已取消此次付款，體驗仍然有效但尚未付款。
          </p>
        </div>
      </div>

      {/* Information */}
      <div className="bg-white dark:bg-background-dark rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 mb-6">
        <h2 className="text-lg font-semibold text-text-light dark:text-text-dark mb-4">接下來您可以</h2>
        
        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <span className="material-symbols-outlined text-primary mt-1">payment</span>
            <div>
              <p className="font-medium text-text-light dark:text-text-dark">重新付款</p>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                您可以隨時回到體驗詳情頁面重新進行付款
              </p>
            </div>
          </div>
          
          <div className="flex items-start gap-3">
            <span className="material-symbols-outlined text-blue-500 mt-1">edit</span>
            <div>
              <p className="font-medium text-text-light dark:text-text-dark">修改體驗</p>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                如需修改體驗時間或服務項目，請聯繫我們
              </p>
            </div>
          </div>
          
          <div className="flex items-start gap-3">
            <span className="material-symbols-outlined text-red-500 mt-1">cancel</span>
            <div>
              <p className="font-medium text-text-light dark:text-text-dark">取消體驗</p>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                如不需要此體驗，您可以在體驗詳情頁面取消
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="space-y-3">
        <Link
          to={`/payment/${paymentId}`}
          className="w-full h-12 flex items-center justify-center bg-primary text-white text-base font-bold rounded-lg hover:bg-primary/90 transition-colors"
        >
          <span className="material-symbols-outlined mr-2">payment</span>
          重新付款
        </Link>
        
        <Link
          to="/bookings"
          className="w-full h-12 flex items-center justify-center bg-gray-200 dark:bg-gray-700 text-text-light dark:text-text-dark text-base font-bold rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
        >
          查看所有體驗
        </Link>
        
        <Link
          to={`/${merchantSlug}`}
          className="w-full h-12 flex items-center justify-center text-primary text-base font-bold rounded-lg hover:bg-primary/10 transition-colors"
        >
          返回首頁
        </Link>
      </div>

      {/* Note */}
      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
        <div className="flex items-start gap-2">
          <span className="material-symbols-outlined text-blue-500 mt-0.5">info</span>
          <div>
            <p className="text-sm font-medium text-blue-700 dark:text-blue-400">溫馨提醒</p>
            <p className="text-xs text-blue-600 dark:text-blue-500 mt-1">
              您的體驗將保留 24 小時，請在此期間內完成付款，否則體驗可能會被自動取消。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentCancelled;